import React from 'react';
import { useTranslation } from 'react-i18next';
import PlotWrapperTooltip from '../../common/PlotWrapper/PlotWrapperTooltip';
import useStyles from './styles';

const TopWidgetPanelTitle = () => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
      <div className={classes.topPanelTitle} >
        {t('ANALYTICS.OVERVIEW')}
        <PlotWrapperTooltip tooltipText={t('ANALYTICS.OVERVIEW_TOOLTIP')} />
      </div>
  );
};


export default TopWidgetPanelTitle;
